import { useEffect, useState } from 'react';
import useNotifications from '../../../shared/hooks/use-notifications';
import { useAtom, useSetAtom } from 'jotai';
import { isMoreMenuOpenAtom, isOnlineAtom, ModalMode, showChangeStatusModalAtom } from '../state';
import { updateAgentStatus } from '../requests/update-agent-status';
import { shouldRefreshteamAtom } from '../../home/v1/states/team-members';
import { AgentStatus } from '../typings';

export const useAgentStatus = () => {
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useAtom(isMoreMenuOpenAtom);
  const [showChangeStatusModal, setShowChangeStatusModal] = useAtom(showChangeStatusModalAtom);
  const [isOnline, setIsOnline] = useAtom(isOnlineAtom);
  const [isLoading, setIsLoading] = useState(false);
  const { addNotification } = useNotifications();
  const setShouldRefreshTeam = useSetAtom(shouldRefreshteamAtom);

  useEffect(() => {
    if (!isOnline) {
      setTimeout(() => {
        setShowChangeStatusModal({ open: true, mode: ModalMode.Inactivity });
      }, 5000);
    } else {
      setShowChangeStatusModal({ open: false, mode: ModalMode.Session });
    }
  }, [isOnline]);

  const handleOpenMoreMenu = () => {
    setIsMoreMenuOpen(!isMoreMenuOpen);
  };

  const changeStatus = async (status: boolean) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      await updateAgentStatus(status ? AgentStatus.ONLINE : AgentStatus.OFFLINE);
      setIsOnline(status);
      setShouldRefreshTeam(true);
      addNotification({
        message: `Status set to ${status ? 'Online' : 'Offline'}`,
        type: status ? 'success' : 'error',
      });
    } catch (error) {
      addNotification({
        message: (error as Error).message || 'Failed to update status. Please try again.',
        type: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isOnline,
    setIsOnline,
    isMoreMenuOpen,
    setIsMoreMenuOpen,
    addNotification,
    handleOpenMoreMenu,
    changeStatus,
    showChangeStatusModal,
    setShowChangeStatusModal,
    isLoading,
  };
};
